module.exports = __webpack_public_path__ + "static/img/D003.b7a7913.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/D003.jpg
// module id = TIlK
// module chunks = 1